module.exports = __webpack_public_path__ + "static/media/dansketext-regular.9a22d8b6.eot";